module.exports = __webpack_public_path__ + "/login_ui/img/om-baea54bc2b3313b46c5867d4314b6cac.svg";